WiseMetering.controller = {
    // helper functions first
    expandNodes: function (model) {
        if (typeof model?.parent !== 'function') {
            return;
        }

        const parents = [];

        let parent = model.parent();
        while (parent) {
            parents.push(parent);
            parent = parent.parent();
        }

        parents.reverse().forEach(parent => parent.trigger('node:expand'));
    },
    // end of helper functions

    createOrganization: function () {
        return new WiseMetering.Views.CreateOrganization({ model: new WiseMetering.Model.Organization });
    },

    editOrganization: function () {
        return new WiseMetering.Views.EditOrganization({ model: WiseMetering.currentOrganization });
    },

    drawDefault: function () {
        Backbone.history.navigate('/home', { trigger: true });
    },

    drawView: view => WiseMetering.layout.content.show(view),

    drawMap: function () {
        const collection = WiseMetering.zones.activeSites();
        this.drawView(new WiseMetering.Views.Map({ collection }));
    },

    drawAdmin: function () {
        this.drawView(new WiseMetering.Views.Admin());
    },

    // All indexes are in one line, because it's always the same code and this way improves readability

    drawActuators: function () {
        this.drawView(new WiseMetering.Views.IndexActuator);
    },

    // <ALARMS>

    drawAlarms: function () {
        this.drawView(new WiseMetering.Views.AlarmTabs);
    },

    drawBulkCreateAlarms: function () {
        this.drawView(new WiseMetering.Views.BulkCreateAlarms());
    },

    drawBulkDeleteAlarms: function () {
        this.drawView(new WiseMetering.Views.BulkDeleteAlarms());
    },

    drawBulkEditAlarms: function () {
        this.drawView(new WiseMetering.Views.BulkEditAlarms());
    },

    drawCreateAlarm: function (indicatorId) {
        this.drawView(new WiseMetering.Views.CreateAlarm({ indicatorId }));
    },

    drawEditAlarm: function (id) {
        var model = WiseMetering.alarms.get(id);

        if (model) {
            this.drawView(new WiseMetering.Views.EditAlarm({ model }));
        } else {
            this.drawDefault();
        }
    },

    drawShowAlarm: function (id) {
        var model = WiseMetering.alarms.get(id);

        if (model) {
            this.drawView(new WiseMetering.Views.ShowAlarm({ model }));
        } else {
            this.drawDefault();
        }
    },

    // </ALARMS>
    drawSite: function (id, view) {
        if (view.indexOf('?') !== -1) {
            [view] = view.split('?');
        }

        const model = WiseMetering.zones.get(id);

        if (model) {
            this.expandNodes(model);
            model.trigger('node:select');
            this.drawView(new WiseMetering.Views.Zone({ model, view }));
        } else {
            this.drawDefault();
        }
    },

    drawSiteTags: function () {
        this.drawView(new WiseMetering.Views.IndexSiteTags);
    },

    drawChat: function () {
        if (!WiseMetering.currentUser || !WiseMetering.currentUser.isSuperUser()) {
            this.drawDefault();
            return;
        }

        this.drawView(new WiseMetering.Views.Chat);
    },

    drawCircuit: function (id) {
        const model = WiseMetering.circuits.get(id);
        if (model) {
            this.expandNodes(model);
            model.trigger('node:select');
            this.drawView(new WiseMetering.Views.Circuit({ model }));
        } else {
            this.drawDefault();
        }
    },

    drawCircuits: function () {
        this.drawView(new WiseMetering.Views.Circuits);
    },

    drawCircuitTags: function () {
        this.drawView(new WiseMetering.Views.IndexCircuitTags);
    },

    drawContract: function (id, view) {
        const model = WiseMetering.contracts.get(id);

        if (model) {
            this.expandNodes(model);
            model.trigger('node:select');
            this.drawView(new WiseMetering.Views.Contract({ model, view }));
        } else {
            this.drawDefault();
        }
    },

    drawCompanies: function () {
        const viewName = WiseMetering.Permissions.hasPlanPermissions('companies') ? 'IndexCompany' : 'NoAccess';
        this.drawView(new WiseMetering.Views[viewName]);
    },

    drawCustomDashboard: function () {
        this.drawView(new WiseMetering.Views.CustomDashboard);
    },

    drawDashboard: function () {
        this.drawView(new WiseMetering.Views.GlobalDashboard());
    },

    drawDevices: function () {
        this.drawView(new WiseMetering.Views.IndexDevice);
    },

    drawEvents: function () {
        this.drawView(new WiseMetering.Views.IndexEvent);
    },

    drawEtls: function () {
        this.drawView(new WiseMetering.Views.IndexEtl);
    },

    drawFolder: function (id) {
        const model = WiseMetering.folders.get(id);

        if (model) {
            this.expandNodes(model);
            model.trigger('node:select');
            this.drawView(new WiseMetering.Views.Folder({ model }));
        } else {
            this.drawDefault();
        }
    },

    drawGlobalIndicators: function () {
        this.drawView(new WiseMetering.Views.IndexGlobalIndicators);
    },

    drawGroups: function () {
        this.drawView(new WiseMetering.Views.IndexGroup);
    },

    drawHolidays: function () {
        this.drawView(new WiseMetering.Views.IndexHoliday);
    },

    drawIndicators: function () {
        this.drawView(new WiseMetering.Views.IndicatorsTabs);
    },

    drawIndicator: function (id, view) {
        const model = WiseMetering.indicators.get(id);

        if (!model) {
            this.drawDefault();
            return;
        }

        let validTabs = ['details', 'events', 'plot', 'objectives'];
        if (model.buckets().length && WiseMetering.currentUser.get('manager') && model.get('type') !== 'mirror') {
            validTabs.push('data');
        }
        if (!view) {
            view = 'plot';
        }

        if (validTabs.includes(view)) {
            this.expandNodes(model);
            model.trigger('node:select');
            this.drawView(new WiseMetering.Views.Indicator({ model, view }));
        } else {
            this.drawDefault();
        }
    },

    // <INTEGRATIONS>

    drawEditIntegration: function (license_id, id) {
        const license = WiseMetering.integrationLicenses.get(license_id);
        const model = WiseMetering.integrations.get(id);

        if (!model || !license) {
            this.drawDefault();
            return;
        }

        if (license.get('partner_slug') === 'nextbitt_maintenance') {
            this.drawView(new WiseMetering.Views.EditNextbittMaintenanceIntegration({ model }));
        } else {
            this.drawDefault();
        }
    },

    drawIntegration: function (id, view) {
        const model = WiseMetering.integrations.get(id);

        if (!model || !WiseMetering.currentUser.get('administrator')) {
            this.drawDefault();
            return;
        }

        const IntegrationView = {
            datelka: WiseMetering.Views.ShowDatelkaIntegration,
            desigo: WiseMetering.Views.ShowDesigoIntegration,
            e_redes: WiseMetering.Views.ShowERedesIntegration,
            shopper_trak: WiseMetering.Views.ShowShopperTrakIntegration,
            sphera: WiseMetering.Views.ShowSpheraIntegration,
            waterbeep: WiseMetering.Views.ShowWaterbeepIntegration,
            wise_json: WiseMetering.Views.ShowWiseJsonIntegration,
            zaptec: WiseMetering.Views.ShowZaptecIntegration
        }[model.partner()?.get('slug')];

        if (!IntegrationView) {
            this.drawDefault();
            return;
        }

        this.drawView(new IntegrationView({ model, view }));
    },

    drawIntegrationLicense: function (id, view = 'integrations') {
        const model = WiseMetering.integrationLicenses.get(id);

        if (!model || !WiseMetering.currentUser.get('administrator')) {
            this.drawDefault();
            return;
        }

        this.drawView(new WiseMetering.Views.IntegrationLicenseTabs({ model, view }));
    },

    drawNewIntegration: function (id) {
        var model = WiseMetering.integrationLicenses.get(id);

        if (!model) {
            this.drawDefault();
            return;
        }

        if (model.get('partner_slug') === 'nextbitt_maintenance') {
            this.drawView(new WiseMetering.Views.NewNextbittMaintenanceIntegration({ model }));
        } else {
            this.drawDefault();
        }
    },

    // </INTEGRATIONS>
    drawWiseStore: function () {
        this.drawView(new WiseMetering.Views.WiseStore);
    },

    drawLeads: function () {
        this.drawView(new WiseMetering.Views.IndexLeads);
    },

    drawLogin: function () {
        if (WiseMetering.currentUser) {
            this.drawDefault();
        } else {
            const view = new WiseMetering.Views.Login;
            WiseMetering.mainRegion.show(view);
        }
    },

    drawNotifications: function () {
        this.drawView(new WiseMetering.Views.IndexNotifications);
    },

    drawMarkers: function () {
        const viewName = WiseMetering.Permissions.hasPlanPermissions('markers') ? 'MarkersTabs' : 'NoAccess';
        this.drawView(new WiseMetering.Views[viewName]);
    },

    drawOrganization: function (id) {
        const model = WiseMetering.currentOrganization;
        this.drawView(new WiseMetering.Views.OrganizationTabs({ model }));
    },

    drawReadings: function () {
        this.drawView(new WiseMetering.Views.IndexReading);
    },

    drawReports: function () {
        this.drawView(new WiseMetering.Views.ReportTabs);
    },

    drawSeu: function (id) {
        const model = WiseMetering.seus.get(id);
        if (model) {
            this.expandNodes(model);
            model.trigger('node:select');
            this.drawView(new WiseMetering.Views.Seu({ model }));
        } else {
            this.drawDefault();
        }
    },

    drawTariffs: function () {
        const viewName = WiseMetering.Permissions.hasPlanPermissions('tariffs') ? 'TariffsTabs' : 'NoAccess';
        this.drawView(new WiseMetering.Views[viewName]);
    },

    drawTenants: function () {
        const viewName = WiseMetering.Permissions.hasPlanPermissions('tenants') ? 'ShowTenantsByOrganization' : 'NoAccess';
        this.drawView(new WiseMetering.Views[viewName]);
    },

    drawTenant: function (id) {
        const model = WiseMetering.tenants.get(id);
        if (model) {
            this.expandNodes(model);
            model.trigger('node:select');
            this.drawView(new WiseMetering.Views.Tenant({ model }));
        } else {
            this.drawDefault();
        }
    },

    drawResetPassword: function (id) {
        const view = new WiseMetering.Views.Login({
            initialAuthState: 'resetPassword',
            code: id
        });
        WiseMetering.mainRegion.show(view);
    },

    drawRootObject: function (id, view) {
        const model = WiseMetering.rootObjects.get(id);

        if (model) {
            this.expandNodes(model);
            model.trigger('node:select');

            if (model.get('slug') === 'utilities') {
                this.drawView(new WiseMetering.Views.UtilitiesRootObject({ model, view }));
            } else {
                this.drawView(new WiseMetering.Views.RootObject({ model }));
            }
        } else {
            this.drawDefault();
        }
    },

    drawSignup: function () {
        if (WiseMetering.currentUser) {
            this.drawDefault();
        } else {
            const view = new WiseMetering.Views.Signup;
            WiseMetering.mainRegion.show(view);
        }
    },

    drawTree: function () {
        const siteId = window.MapService.siteIds.at(0);

        if (siteId) {
            Backbone.history.navigate(WiseMetering.zones.get(siteId).nodeUrl(), { replace: true, trigger: true });
        } else {
            WiseMetering.layout.showTipper('error', i18next.t('sites.no_sites_available'), 5000);
            Backbone.history.navigate('/', { replace: true, trigger: true });
        }
    },

    drawUsers: function () {
        this.drawView(new WiseMetering.Views.IndexUser);
    },

    drawUserProfile: function () {
        this.drawView(new WiseMetering.Views.UserProfile);
    },

    drawUtility: function (id, view) {
        if (!view) {
            view = 'details';
        }
        if (view.indexOf('?') !== -1) {
            [view] = view.split('?');
        }

        const model = WiseMetering.utilities.get(id);
        if (model) {
            this.expandNodes(model);
            model.trigger('node:select');
            this.drawView(new WiseMetering.Views.Utility({ model, view }));
        } else {
            this.drawDefault();
        }
    },

    drawZoneAttributes: function () {
        this.drawView(new WiseMetering.Views.IndexZoneAttributes);
    },

    drawZone: function (id, view) {
        if (!view) {
            view = 'dashboard';
        }
        if (view.indexOf('?') !== -1) {
            [view] = view.split('?');
        }

        const model = WiseMetering.zones.get(id);
        if (model) {
            this.expandNodes(model);
            model.trigger('node:select');
            this.drawView(new WiseMetering.Views.Zone({ model, view }));
        } else {
            this.drawDefault();
        }
    }
};
